import gql from "graphql-tag";
import getNextStep from "state/getNextStep";
import { showIndex } from "utils/navigation";
import validateStep from "state/validateStep";

export const completeStepMutation = gql`
  mutation completeStep {
    completeStep @client
  }
`;

const completeStepQuery = gql`
  query {
    wizard @client {
      currentStep
    }

    dirtyState @client {
      ruleName
    }
  }
`;

export const completeStep = (_, args, { cache }) => {
  const cachedData = cache.readQuery({ query: completeStepQuery });
  const currentStep = cachedData.wizard.currentStep;

  const nextStep = getNextStep(currentStep);

  if (nextStep === "complete") {
    showIndex({ skipDirtyCheck: true });
  } else {
    const isValid = validateStep(currentStep, cachedData);

    if (isValid) {
      const data = {
        wizard: {
          __typename: "Wizard",
          currentStep: nextStep,
          showValidation: false,
        },
        articleMatchesPage: 1,
      };

      cache.writeData({ data });
    } else {
      const data = {
        wizard: {
          __typename: "Wizard",
          currentStep,
          showValidation: true,
        },
      };

      cache.writeData({ data });
    }
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/mutations/completeStepMutation.js